// extracted by mini-css-extract-plugin
export default {"container":"Ms5j28"};